import { v4 as uuidv4 } from 'uuid';

function getClientName(location) {
  const { pathname } = location;
  const isCPS = pathname.includes('/en-us/credit-cards/apply/personal/');
  const clientName = isCPS ? 'cps' : 'GAC'; // clientName = GAC if intl or clientName = cps if US Consumer
  return clientName;
}

export const onLoadInAuth = (actSetInAuthUUID, location) => () => {
  const clientName = getClientName(location);
  const uuid = uuidv4();
  if (window.inauthSetTid) {
    window.inauthSetTid(uuid, clientName);
    actSetInAuthUUID(uuid);
  }
};
